<template>
  <div class="chipsContainer" :id="'item' + item.id">
    <div class="label label-secondary chips text-dark">
      {{ item.name }}
      <i class="fa fa-times-circle pointer" @click="close()"></i>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    item: {},
  },
  methods: {
    ...mapActions(["removeCourse"]),
    close() {
      this.removeCourse(this.item.id);
    },
  },
};
</script>
<style>
.label-secondary {
  background-color: #ffc700;
}
.chips {
  border-radius: 15px !important;
  font-size: 20px;
  width: auto;
}

.chipsContainer {
  margin-top: 10px;
  margin-bottom: 10px;
}

.pointer {
  cursor: pointer;
}
</style>
